import React from "react";
import PlannerBadge from "./PlannerBadge";

export default function WorkerCard({
  worker,
  inactive,
  availabilityMeta,
  reliabilityScore,
  editWorkerUid,
  setEditWorkerUid,
  expandedWorkerUid,
  setExpandedWorkerUid,
  selectedShiftId,
  setMatchSelectedShiftRole,
  CredentialBadges,
}) {
  return (
    <div
      key={worker.uid}
      onClick={() => {
        setEditWorkerUid(worker.uid);
        if (selectedShiftId) {
          setMatchSelectedShiftRole(true);
        }
      }}
      className={'schedule-worker-card'+(editWorkerUid === worker.uid ? ' is-picked' : '')+(inactive ? ' is-inactive' : '')}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr auto",
          gap: 8,
          alignItems: "start",
        }}
      >
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              display: "flex",
              gap: 6,
              alignItems: "center",
              minWidth: 0,
            }}
          >
            <span
              style={{
                width: 9,
                height: 9,
                borderRadius: "50%",
                background:
                  worker.workerOperationalState === "READY"
                    ? "#16a34a"
                    : worker.workerOperationalState === "ACTION_REQUIRED"
                    ? "#dc2626"
                    : "#f59e0b",
                flex: "0 0 auto",
              }}
            />

            <span
              style={{
                fontWeight: 650,
                fontSize: 13,
                color: "#0f172a",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: 150,
              }}
              title={worker.email || worker.uid}
            >
              {worker.displayName ||
                worker.fullName ||
                worker.name ||
                worker.email?.split("@")[0] ||
                worker.uid}
            </span>
          </div>

          <div
            style={{
              marginTop: 6,
              display: "flex",
              gap: 5,
              flexWrap: "wrap",
            }}
          >
        
        <PlannerBadge
  bg="#eff6ff"
  border="#bfdbfe"
  color="#1d4ed8"
  uppercase
>
  {worker.approvedPositions?.[0] ||
    worker.positions?.[0] ||
    worker._validTypes?.[0] ||
    worker.position ||
    worker.primaryRole ||
    worker.licenseType ||
    (String(worker.workerType || "").toUpperCase() === "WORKER"
      ? ""
      : worker.workerType) ||
    worker.roleType ||
    worker.role ||
    "WORKER"}
</PlannerBadge>

         <PlannerBadge
  bg={availabilityMeta.bg}
  border={availabilityMeta.border}
  color={availabilityMeta.color}
  uppercase
>
  {availabilityMeta.label}
</PlannerBadge>

        <PlannerBadge>
  ⭐ {reliabilityScore}
</PlannerBadge>
          </div>
        </div>

        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setExpandedWorkerUid(
              expandedWorkerUid === worker.uid ? null : worker.uid
            );
          }}
          style={{
            border: "1px solid #dbe4ee",
            background: "#ffffff",
            borderRadius: 999,
            cursor: "pointer",
            fontWeight: 650,
            color: "#2563eb",
            fontSize: 11,
            padding: "4px 8px",
          }}
        >
          {expandedWorkerUid === worker.uid ? "Hide" : "View"}
        </button>
      </div>

      {editWorkerUid === worker.uid ? (
        <div
          style={{
            marginTop: 8,
            padding: "7px 9px",
            borderRadius: 10,
            background: "#eff6ff",
            border: "1px solid #bfdbfe",
            color: "#1d4ed8",
            fontSize: 11,
            fontWeight: 600,
          }}
        >
          Selected for assignment
        </div>
      ) : null}

      {expandedWorkerUid === worker.uid ? (
        <div
          style={{
            marginTop: 8,
            paddingTop: 8,
            borderTop: "1px solid #e5e7eb",
            display: "grid",
            gap: 5,
            fontSize: 11,
            color: "#334155",
            fontWeight: 800,
          }}
        >
          <div>📞 {worker.phone || "No phone"}</div>
          <div>✉ {worker.email || "No email"}</div>
          <div style={{ color: "#166534", fontWeight: 600 }}>
            Reliability {reliabilityScore}
          </div>
          <div
            style={{
              color:
                worker.workerOperationalState === "READY"
                  ? "#166534"
                  : "#dc2626",
              fontWeight: 600,
            }}
          >
            Status: {worker.workerOperationalState || "UNKNOWN"}
          </div>
          <div>Last Shift: {worker.lastShiftDate || "No history"}</div>
          <div style={{ color: "#166534", fontWeight: 600 }}>
            Credentials: {Array.isArray(worker._allCreds) ? worker._allCreds.length : 0}/4
          </div>

          <CredentialBadges worker={worker} />

          <div>Account access is managed by an administrator.</div>
        </div>
      ) : null}
    </div>
  );
}